import { ConferenceOrderFilterPayload } from './types'

export const normalizeConferenceSearch = (value?: string): string => {
  return (value || '').trim()
}

export const isNumericSearch = (value: string): boolean => {
  return /^\d+$/.test(value)
}

export const buildNinegridConferenceRequests = (
  payload: ConferenceOrderFilterPayload
): Array<Omit<ConferenceOrderFilterPayload, 'orderSearch'>> => {
  const normalizedSearch = normalizeConferenceSearch(payload.orderSearch)
  const normalizedLegacyOrderId =
    payload.orderId != null && Number.isFinite(Number(payload.orderId))
      ? String(payload.orderId).trim()
      : ''
  const normalizedLegacyOrderExt = normalizeConferenceSearch(payload.orderidExt)
  const effectiveSearch = normalizedSearch || normalizedLegacyOrderExt || normalizedLegacyOrderId

  const basePayload: Omit<ConferenceOrderFilterPayload, 'orderSearch'> = {
    startDate: payload.startDate,
    finalDate: payload.finalDate,
    ...(payload.customerName ? { customerName: payload.customerName } : {}),
    ...(payload.cpfSeller ? { cpfSeller: payload.cpfSeller } : {}),
    ...(payload.codeSeller ? { codeSeller: payload.codeSeller } : {}),
  }

  if (!effectiveSearch) {
    return [basePayload]
  }

  const requests: Array<Omit<ConferenceOrderFilterPayload, 'orderSearch'>> = []
  if (isNumericSearch(effectiveSearch)) {
    requests.push({
      ...basePayload,
      orderId: Number(effectiveSearch),
    })
  }

  requests.push({
    ...basePayload,
    orderidExt: effectiveSearch,
  })

  return requests
}

export const buildTotvsConferenceRequests = (
  payload: ConferenceOrderFilterPayload,
  page: number,
  pageSize: number
): Record<string, unknown>[] => {
  const normalizedSearch = normalizeConferenceSearch(payload.orderSearch)
  const normalizedLegacyOrderId = normalizeConferenceSearch(
    payload.orderId != null ? String(payload.orderId) : ''
  )
  const normalizedLegacyOrderExt = normalizeConferenceSearch(payload.orderidExt)
  const unifiedOrderSearch = normalizedSearch || normalizedLegacyOrderExt || normalizedLegacyOrderId

  const baseRequest: Record<string, unknown> = {
    startDate: payload.startDate,
    endDate: payload.finalDate,
    ...(payload.customerName ? { customerName: payload.customerName } : {}),
    ...(payload.cpfSeller ? { sellerCpfCnpj: payload.cpfSeller } : {}),
    ...(payload.codeSeller ? { sellerCode: payload.codeSeller } : {}),
    page,
    pageSize,
  }

  if (isNumericSearch(unifiedOrderSearch)) {
    return [
      {
        ...baseRequest,
        orderCode: Number(unifiedOrderSearch),
      },
      {
        ...baseRequest,
        orderId: unifiedOrderSearch,
      },
    ]
  }

  return [baseRequest]
}